export default function PageHero({ eyebrow, title, description, image }) {
  return (
    <section className="relative overflow-hidden bg-slate-900 text-white" data-testid="page-hero">
      {image && (
        <div
          className="absolute inset-0 bg-cover bg-center opacity-30"
          style={{ backgroundImage: `url(${image})` }}
          aria-hidden
        />
      )}
      <div className="absolute inset-0 hero-overlay" aria-hidden />
      <div className="container-nago relative py-20 sm:py-24 lg:py-28">
        {eyebrow && (
          <div className="text-xs font-bold uppercase tracking-[0.24em] text-red-300">
            {eyebrow}
          </div>
        )}
        <h1 className="mt-4 font-display font-extrabold text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight max-w-3xl">
          {title}
        </h1>
        {description && (
          <p className="mt-6 text-slate-300 text-base sm:text-lg leading-relaxed max-w-2xl">
            {description}
          </p>
        )}
      </div>
    </section>
  );
}
